import { css } from "@emotion/react";
import styled from "@emotion/styled";

export const StyleDiv = styled.div<{
  $marginBottom?: number;
  $marginTop?: number;
  $flex?: boolean;
  $justifyContent?: string;
}>`
  margin-bottom: ${(props: any) => props.$marginBottom || 0}px;
  margin-top: ${(props: any) => props.$marginTop || 0}px;
  width: 100%;
  flex: 1;
  ${(props: any) =>
    props.$flex &&
    css`
      display: flex;
      justify-content: ${(props: any) =>
        props.$justifyContent || "space-between"};
      align-items: center;
      gap: 20px;
    `}

  @media(max-width: 800px) {
    flex-direction: column;
  }
`;
